<template>
  <div class="counter">
    <div>
      <span class="value">{{ this.interValue }}</span>
      <span class="symbol">%</span>
      <span v-if="type === 'increase'">
        <img src="../assets/img/home/increase.png" alt="" />
      </span>
      <span v-if="type === 'decrease'">
        <img src="../assets/img/home/decrease.png" alt="" />
      </span>
    </div>
    <p class="label">{{ this.label }}</p>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, requires: true },
    value: { type: Number, requires: true },
    type: {
      validator (value) {
        return ["increase", "decrease"].includes(value);
      },
      default: "increase"
    }
  },
  data () {
    return {
      interValue: 0,
      timer: null
    };
  },
  watch: {
    value (newVal, oldVal) {
      
      if (newVal) {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          this.interValue = this.interValue + 1;
          if (this.interValue === newVal) {
            clearInterval(this.timer);
          }
        }, 25);
      }else {
        this.interValue = 0
      }
    }
  },
  mounted: function () {
  },
  computed: {},
  methods: {}
};
</script>
<style lang="scss">
.counter {
  .value {
    font-size: 60px;
    font-family: DINAlternate, DINAlternate-Bold;
    font-weight: 700;
    color: #1f2329;
  }
  img {
    width: 30px;
    height: 33px;
    vertical-align: top;
    margin-top: 15px;
  }
  .symbol {
    font-size: 30px;
    font-weight: 600;
    color: #1f2329;
  }

  .label {
    font-size: 20px;
    font-weight: 500;
    color: #1f2329;
    margin-top: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/counter.vue